


























import { ref, defineComponent } from "@vue/composition-api"

import Icon from "@/components/icon.vue"
import clickoutside from "@/directives/clickoutside"
import { useToggle } from "@shared/use/use-toggle"
import { LANGUAGE_LIST, setLang, AllLanguages } from "@/locales"

export default defineComponent({
  components: {
    Icon,
  },
  directives: {
    clickoutside,
  },
  setup(props, { emit }) {
    const [visible, toggleVisible] = useToggle()

    const switchLanguage = (language: AllLanguages) => {
      setLang(language)
      emit("switch", language)
    }

    return {
      visible,
      list: LANGUAGE_LIST,
      switchLanguage,
      hidePanel: () => toggleVisible(false),
      toggleVisible,
    }
  },
})
